/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIUserSearchResult } from './APIUserSearchResult';
import {
    APIUserSearchResultFromJSON,
    APIUserSearchResultFromJSONTyped,
    APIUserSearchResultToJSON,
} from './APIUserSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIUserSearchResponse
 */
export interface APIUserSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIUserSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIUserSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIUserSearchResult>}
     * @memberof APIUserSearchResponse
     */
    results: Array<APIUserSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIUserSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIUserSearchResponse interface.
 */
export function instanceOfAPIUserSearchResponse(value: object): value is APIUserSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIUserSearchResponseFromJSON(json: any): APIUserSearchResponse {
    return APIUserSearchResponseFromJSONTyped(json, false);
}

export function APIUserSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIUserSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIUserSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIUserSearchResponseToJSON(value?: APIUserSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIUserSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

